import API, { APIResponse } from '../api/index'

export const getAnnounces = (): Promise<APIResponse> => {
  return API.request('GET', '/api/v3/announces', {}, true)
}
